import { commonRequestData, fetchData, fetchDataFile } from "../../api";

export const traerTodasLasEmpresas = async () => {
    // Prepara los datos comunes necesarios para la solicitud, como parámetros generales
    const requestData = {
        ...commonRequestData, // Combina los datos comunes (commonRequestData) con otros parámetros necesarios para la solicitud
    };

    // Realiza una solicitud a la API utilizando fetchData para obtener la lista de empresas
    // El primer parámetro "empresas" especifica el endpoint o recurso al que se realizará la petición
    const response = await fetchData("empresas", requestData);

    // Retorna la respuesta obtenida de la API, que contiene la lista de empresas
    return response;
};

export const extraerDatosDeEmpresa = async ({ idempresa }) => {
    // Prepara los datos comunes necesarios para la solicitud y añade el id específico de la empresa
    const requestData = {
        ...commonRequestData, // Combina los datos comunes (commonRequestData) con otros parámetros necesarios para la solicitud
        idempresa, // Agrega el ID de la empresa que se desea consultar
    };

    // Realiza una solicitud a la API utilizando fetchData para obtener la información detallada de una empresa
    // El primer parámetro "empresas/informacion" indica el endpoint específico para extraer los datos de una empresa en particular
    const response = await fetchData("empresas/informacion", requestData);

    // Retorna la respuesta obtenida de la API, que contiene la información detallada de la empresa
    return response;
};

export const obtenerDetallesClientesEmpresa = async ({ idEmpresa }) => {
    // Configura los datos necesarios para la solicitud, incluyendo el ID específico de la empresa
    const requestData = {
        ...commonRequestData, // Combina los datos comunes para la solicitud (commonRequestData) con otros parámetros adicionales
        idEmpresa, // Añade el ID de la empresa que se desea consultar para obtener sus clientes
    };

    // Realiza una solicitud a la API utilizando `fetchData`, para obtener la lista de clientes de la empresa
    // "empresas/clientes" indica el endpoint específico para extraer los datos de clientes asociados a la empresa
    const response = await fetchData("empresas/clientes", requestData);

    // Devuelve la respuesta de la API, que contiene la lista de clientes y detalles específicos de la empresa consultada
    return response;
};

export const actulizarLogodeempresa = async (formData) => {
    //  console.log("FormData before sending:", Array.from(formData.entries()));
    // cuerpo de la solicitud que se enviará al servidor.
    const requestData = {
        formData,
    };
    // Realiza una solicitud utilizando fetchData y retorna la respuesta
    return await fetchDataFile("empresas/logo", requestData);
};

export const actulizarDatosenbasededatos = async ({ array }) => {
    // cuerpo de la solicitud que se enviará al servidor.
    const requestData = {
        ...commonRequestData,
        array,
    };
    // Realiza una solicitud utilizando fetchData y retorna la respuesta
    return await fetchData("empresas/ActualizarImage", requestData);
};

export const getBitacora_Empresa = async ({ idempresa }) => {
    // Prepara los datos comunes necesarios para la solicitud y añade el id específico de la empresa
    const requestData = {
        ...commonRequestData, // Combina los datos comunes (commonRequestData) con otros parámetros necesarios para la solicitud
        idempresa, // Agrega el ID de la empresa que se desea consultar
    };

    // Realiza una solicitud a la API utilizando fetchData para obtener la información detallada de una empresa
    // El primer parámetro "empresas/informacion" indica el endpoint específico para extraer los datos de una empresa en particular
    const response = await fetchData("empresas/bitacora", requestData);

    // Retorna la respuesta obtenida de la API, que contiene la información detallada de la empresa
    return response;
};

export const insertartBitacora_Empresa = async ({ nota, id_empresa, id_admin, name_admin }) => {
    // Prepara los datos comunes necesarios para la solicitud y añade el id específico de la empresa
    const requestData = {
        ...commonRequestData, // Combina los datos comunes (commonRequestData) con otros parámetros necesarios para la solicitud
        nota,
        id_empresa,
        id_admin,
        name_admin,
    };

    // Realiza una solicitud a la API utilizando fetchData para obtener la información detallada de una empresa
    // El primer parámetro "empresas/informacion" indica el endpoint específico para extraer los datos de una empresa en particular
    const response = await fetchData("empresas/Insertarbitacora", requestData);

    // Retorna la respuesta obtenida de la API, que contiene la información detallada de la empresa
    return response;
};

/**
 * Sends a request to create a new company record, including associated admin details.
 *
 * @param {Object} params - An object containing:
 *        - {Object} empresaData - Data object for the company to be created.
 *        - {string} id_admin - Admin ID creating the company record.
 *        - {string} name_admin - Admin name creating the company record.
 * @returns {Promise<Object>} The API response containing the result of the company creation.
 */
export const crearNuevaEmpresa = async ({ empresaData, id_admin, name_admin }) => {
    // Prepare the request data by merging common request parameters with company-specific data
    const requestData = {
        ...commonRequestData, // Contains default request parameters shared across API calls
        empresaData,
        id_admin,
        name_admin,
    };

    // Make a request to the API to create a new company record
    // The endpoint "empresas/crearNuevaEmpresa" is used specifically for adding new company entries
    const response = await fetchData("empresas/crearNuevaEmpresa", requestData);

    // Return the full response from the API, which includes details about the created company record
    return response;
};

/**
 * Sends a request to update an existing company record, including associated admin details.
 *
 * @param {Object} params - An object containing:
 *        - {Object} empresaData - Data object with updated information for the company.
 *        - {string} id_admin - Admin ID performing the update.
 *        - {string} name_admin - Admin name performing the update.
 * @returns {Promise<Object>} The API response containing the result of the company update.
 */
export const editarDatosEmpresa = async ({ empresaData }) => {
    // Prepare the request data by merging common request parameters with the updated company-specific data
    const requestData = {
        ...commonRequestData, // Contains default request parameters shared across API calls
        empresaData,
    };

    // Make a request to the API to update the existing company record
    // The endpoint "empresas/editarEmpresa" is used specifically for updating company entries
    const response = await fetchData("empresas/editarEmpresa", requestData);

    // Return the full response from the API, which includes details about the updated company record
    return response;
};

/**
 * Sends a request to update the status of an existing company, including updated details and status.
 *
 * @param {Object} params - An object containing:
 *        - {Object} empresaDetails - Object with the updated details of the company.
 *        - {string} status - New status to be assigned to the company.
 * @returns {Promise<Object>} The API response with the result of the update request.
 */
export const cambiarelestado_Empresa = async ({ empresaDetails, status }) => {
    // Combine common request data with specific company details and the new status
    const requestData = {
        ...commonRequestData, // Shared default request parameters used in API calls
        empresaDetails,
        status,
    };

    // Make an API request to update the company's status using the "cambiarelestado_Empresa" endpoint
    const response = await fetchData("empresas/cambiarelestado_Empresa", requestData);

    // Return the API response, which contains details of the updated company record
    return response;
};
